import React, { useMemo, useEffect } from 'react';
import { briefRuntimeStore, updateQueryParams } from '@fiverr-private/variations_display';
import { UserAgentContext } from '../../../shared/components/UserAgentContext';
import monitor from '../../../service/bigquery';
import { useOnceBeforeRender } from '../../../shared/hooks';
import { RolloutsContext } from '../../../shared/components/RolloutsContext';
import { type UserAgentData } from '../../../shared/lib/getUserAgent';
import { type TrackingData } from '../../../shared/lib/getTrackingData';
import ChooseVariation from '../../components/ChooseVariation/ChooseVariation';

interface ClientChooseVariationPageProps {
  appData: {
    projectData: any;
    draftsVariations: any;
    ordersVariations: any;
    savedDrafts: any;
    userSavedProject: any;
    sellerData: any;
    availablePackages: any;
    hasFreeVariations: any;
    simplifiedPackageType: any;
  };
  context: any;
  briefData: any;
  userAgent: UserAgentData;
  currentUser: any;
  httpRequest: any;
  tracking: TrackingData;
  rollouts: Record<string, boolean>;
}

export default function ClientChooseVariationPage({
  appData: {
    projectData,
    draftsVariations,
    ordersVariations,
    userSavedProject,
    sellerData,
    availablePackages,
    hasFreeVariations,
    simplifiedPackageType,
  },
  context: serverContext,
  briefData,
  userAgent,
  currentUser,
  httpRequest,
  tracking,
  rollouts,
}: ClientChooseVariationPageProps) {
  const storedBriefLogoName = briefRuntimeStore.getBriefLogoName();

  const context = useMemo(
    () => ({ ...serverContext, ...storedBriefLogoName }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  useOnceBeforeRender(() => {
    monitor.initialize(tracking);
  });

  useEffect(() => {
    if (storedBriefLogoName) {
      updateQueryParams({
        brand_name: storedBriefLogoName.brandName,
        slogan: storedBriefLogoName.slogan,
      });
      briefRuntimeStore.clearBrief();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <RolloutsContext.Provider value={rollouts}>
      <UserAgentContext.Provider value={userAgent}>
        <ChooseVariation
          projectData={projectData}
          userSavedProject={userSavedProject}
          draftsVariations={draftsVariations}
          ordersVariations={ordersVariations}
          currentUser={currentUser}
          httpRequest={httpRequest}
          sellerData={sellerData}
          context={context}
          briefData={briefData}
          availablePackages={availablePackages}
          hasFreeVariations={hasFreeVariations}
          simplifiedPackageType={simplifiedPackageType}
        />
      </UserAgentContext.Provider>
    </RolloutsContext.Provider>
  );
}
